import { useContext } from 'react';

import SiteSettingsContext from './SiteSettingsContext';

const useSiteSettings = () => useContext(SiteSettingsContext);

export default useSiteSettings;
